import React, { FC, memo } from "react";

import { SocBindCallbackScreen } from "../";

export const BindGoogleRedirect: FC = memo(() => <SocBindCallbackScreen network="google" />);
